<template>
  <div>
    <div class="primary--text">
      {{ formType === 'add' ? $t('create_company') : $t('edit_company') }}
    </div>
    <form class="form-control" :class="{ 'has-error': errors.has('projectId') }">
      <label>{{ $t('project_id') }} <span class="red--text">*</span></label>
      <input
        v-model="input.project_id"
        v-validate="'required'"
        name="projectId"
        type="text"
        :data-vv-as="$t('project_id')"
      />
      <span v-if="errors.has('projectId')" class="text-error">{{ errors.first('projectId') }}</span>
    </form>
    <form class="form-control" :class="{ 'has-error': errors.has('companyCode') }">
      <label>{{ $t('company_code') }} <span class="red--text">*</span></label>
      <input
        v-model="input.company_code"
        v-validate="'required'"
        name="companyCode"
        type="text"
        :data-vv-as="$t('company_code')"
      />
      <span v-if="errors.has('companyCode')" class="text-error">{{
        errors.first('companyCode')
      }}</span>
    </form>
    <form class="form-control" :class="{ 'has-error': errors.has('companyName') }">
      <label>{{ $t('company_name') }} <span class="red--text">*</span></label>
      <input
        v-model="input.company_name"
        v-validate="'required'"
        name="companyName"
        type="text"
        :data-vv-as="$t('company_name')"
      />
      <span v-if="errors.has('companyName')" class="text-error">{{
        errors.first('companyName')
      }}</span>
    </form>
    <form class="form-control" :class="{ 'has-error': errors.has('teamId') }">
      <label>{{ $t('team_id') }} <span class="red--text">*</span></label>
      <input
        v-model="input.team_id"
        v-validate="'required'"
        name="teamId"
        type="text"
        :data-vv-as="$t('team_id')"
      />
      <span v-if="errors.has('teamId')" class="text-error">{{ errors.first('teamId') }}</span>
    </form>
    <div class="text-xs-center">
      <v-btn outline color="grey" @click="handleCancel">{{ $t('cancel') }}</v-btn>
      <v-btn
        :loading="loading"
        :disabled="loading"
        depressed
        color="primary"
        @click="handleSaveCompany"
        >{{ $t('Save') }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import rootsApi from '@/api/roots'
import { mapGetters } from 'vuex'

export default {
  props: ['formType', 'value'],
  data() {
    return {
      input: {
        company_code: '',
        company_name: '',
        project_id: '',
        team_id: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.value) {
      this.input.project_id = this.value.project_id
      this.input.company_code = this.value.company_code
      this.input.company_name = this.value.company_name
      this.input.team_id = this.value.team_id
    }
  },
  methods: {
    async handleSaveCompany() {
      const vm = this
      try {
        const result = await vm.$validator.validateAll()
        if (!result) {
          vm.goToErrorInput()
          return false
        }

        const data = {
          project_id: vm.input.project_id,
          company_code: vm.input.company_code,
          company_name: vm.input.company_name,
          team_id: vm.input.team_id
        }

        vm.$store.dispatch('loading')

        let response = null
        if (vm.formType === 'add') {
          response = await vm.createCompany(data)
        } else {
          Object.assign(data, { id: vm.value.id })
          response = await vm.updateCompany(data)
        }

        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          this.$emit('success')
        }
      } catch (error) {
        console.error(error)
        vm.loading = false
      }
    },
    async createCompany(payload) {
      try {
        const response = await rootsApi.postCreateCompany({
          data: payload,
          pageId: this.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async updateCompany(payload) {
      try {
        const response = await rootsApi.putUpdateCompany({
          data: payload,
          pageId: this.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleCancel() {
      this.input = {
        company_code: '',
        company_name: ''
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Roots/CompanyManage.vue